export default function Error404Page(): JSX.Element {
    return <div className="page-content">
        <h1>Chyba 404</h1>
        <p>Stránka bohužel neexistuje, zkus kliknou <a href="/">sem</a>.</p>
    </div>;
}
